import React from "react";
import moment from "jalali-moment";
import {useActions} from "../hooks/useActions";
interface GuildListLogProps{
  setShowGuildBottomSheet : any
  guildData : any
}
const GuildListLog : React.FC<GuildListLogProps> = ({setShowGuildBottomSheet , guildData}) => {
  const {fetchGuildSingle} = useActions();
  const handleShowGuildBottomSheet = (qrCode : any) => {
    fetchGuildSingle(qrCode);
    setShowGuildBottomSheet(true);
  }

  return (
    <div className="guild-record-box ">
      <div className="guild-record-box__header">
        <span>رسته</span>
        <span>تاریخ</span>
        <span>آدرس</span>
      </div>
      <div className="guild-record-box__body">
        {
          guildData.map((guild : any , index : any)=>{
            let visitDate = moment(guild.visitDate, "YYYY/MM/DD")
              .locale("fa")
              .format("YYYY/MM/DD")
            return (
              <div className="guild-record-box__body__row" onClick={()=>handleShowGuildBottomSheet(guild.visitInfo.qrCode)} key={index}>
                <span>
                  <i>{++index}.</i>
                  {guild.visitInfo.category}
                </span>
                <span>{visitDate}</span>
                <span>{guild.visitInfo.address}</span>
              </div>
            )
          })
        }


      </div>
    </div>
  )
}

export default GuildListLog;